module.exports = __webpack_public_path__ + "static/media/AP-OTF-A1GothicStd-Regular.d1bb8ff5.otf";